/* eslint-disable react/prop-types */

import React, { useState, useEffect, useContext } from "react";

import { DocumentContext } from "~context/DocumentContext";
import { AppContext } from "~context/AppContext";

import Service from "~components/case-study/Service";

import { toggleArrayItem } from "~utils/helpers";

const Services = ({ tagline, services, fontColor }) => {
  const { scrollTop } = useContext(DocumentContext);

  const { aLaCarte, setALaCarte } = useContext(AppContext);

  const [activeTooltip, setActiveTooltip] = useState(null);

  const activateTooltip = (e, id) => {
    e.stopPropagation();

    setActiveTooltip(id);
  };

  const toggleALaCarte = item => {
    setALaCarte(toggleArrayItem(aLaCarte, item));
  };

  useEffect(() => {
    setActiveTooltip(null);
  }, [scrollTop]);

  return (
    <section className="w-full relative block pt-v7 xs:pt-v14 pb-v14 xs:pb-v28">
      <div className="grid">
        <h2 className="grid-end-12 f2 universal-sans">{tagline}</h2>
      </div>

      <div className="grid mt-v7 xs:mt-v14">
        {services?.[0] &&
          services.map(servicesItem => {
            const selected = aLaCarte.includes(servicesItem.text);
            const focused = activeTooltip === servicesItem.text;

            //

            return (
              <Service
                servicesItem={servicesItem}
                selected={selected}
                focused={focused}
                activateTooltip={activateTooltip}
                setActiveTooltip={setActiveTooltip}
                toggleALaCarte={toggleALaCarte}
                fontColor={fontColor}
              />
            );
          })}
      </div>
    </section>
  );
};

export default Services;
